import axiosInstance from "../instance/axiosInstance";

class HQBranchesApi {
  static async getCitiesFromCountry(countryId, page, searchQuery) {
    let url = `/settings/country/${countryId}/cities?page=${page}`;

    if (searchQuery) {
      url += `&search_name=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getHqBranches(page) {
    try {
      const response = await axiosInstance.get(`/location/list?page=${page}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async getHqBranchesListWithoutPg() {
    try {
      const response = await axiosInstance.get("/getBranchesHQ-without-pg");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async createHqBranch(formData) {
    try {
      const response = await axiosInstance.post(`/location/save`, formData);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async updateHqBranch(id, formData) {
    try {
      const response = await axiosInstance.post(
        `/location/update/${id}`,
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async changeHqBranchStatus(id, formData) {
    try {
      const response = await axiosInstance.post(
        `/location/status-update/${id}`,
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async deleteHqBranch(id) {
    try {
      const response = await axiosInstance.delete(`/location/delete/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getHqBranchHistory(id) {
    try {
      const response = await axiosInstance.get(`/location/history/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getHqBranchDetails(id) {
    try {
      const response = await axiosInstance.get(`/location/view/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async createDepartment(id, formData) {
    try {
      const response = await axiosInstance.post(
        `/location/${id}/department/save`,
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getDepartmentsList(id) {
    try {
      const response = await axiosInstance.get(
        `/location/${id}/department/list`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getSingleDepartment(hqBranchId, departmentId) {
    try {
      const response = await axiosInstance.get(
        `/location/${hqBranchId}/department/view/${departmentId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async updateDepartment(hqBranchId, departmentId, formData) {
    try {
      const response = await axiosInstance.post(
        `/location/${hqBranchId}/department/update/${departmentId}`,
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async deleteDepartment(hqBranchId, departmentId) {
    try {
      const response = await axiosInstance.delete(
        `/location/${hqBranchId}/department/delete/${departmentId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async changeDepartmentStatus(hqBranchId, departmentId, formData) {
    try {
      const response = await axiosInstance.post(
        `/location/${hqBranchId}/department/status-update/${departmentId}`,
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getDepartmentHistory(hqBranchId, departmentId) {
    try {
      const response = await axiosInstance.get(
        `/location/${hqBranchId}/department/history/${departmentId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getCompleteHQBranchesList() {
    try {
      const response = await axiosInstance.get(
        `/getBranchesHQ-without-pg`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getCompleteDepartmentsList(id) {
    try {
      const response = await axiosInstance.get(
        `/getDepartments-without-pg/${id}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async getBranchesDepartments() {
    try {
      const response = await axiosInstance.get("/getBranchesDepartments");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}



export default HQBranchesApi;
